import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectVirtualGraphSelector = memoizeSelectorFactory(
  (projectId: string, virtualGraphId: string | undefined) =>
    createSelector(
      projectSelector(projectId),
      (project) =>
        (virtualGraphId && project?.virtualGraphsById[virtualGraphId]) || null
    )
);
